import script from "./gameLogView.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameLogView.vue?vue&type=script&setup=true&lang=ts"

import "./gameLogView.vue?vue&type=style&index=0&id=0528d608&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0528d608"]])

export default __exports__